import { ITradingStatusLiveData, socketService } from '@aqx-core/common/socket';

import { ETradingStatusMessageType, ITradingStatusTopicMessage } from '../topics/trading-status';

class TradingStatusTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    updateQuoteData: (symbolId: string, updatedData: ITradingStatusLiveData) => void
  ) => {
    socketService.topics().tradingStatus.subscribe({
      symbol: symbol,
      receiver: { subscriptionKey, payload: (payload) => this.tradingStatusTopicReceiver(payload, updateQuoteData) }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    updateQuoteData: (symbolId: string, updatedData: ITradingStatusLiveData) => void
  ) => {
    socketService.topics().tradingStatus.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => this.tradingStatusTopicReceiver(payload, updateQuoteData)
      }
    });
  };

  private tradingStatusTopicReceiver = (
    payload: ITradingStatusTopicMessage | undefined,
    updateOptionChainData: (symbolId: string, updatedData: ITradingStatusLiveData) => void
  ) => {
    if (payload && payload.M === ETradingStatusMessageType.LIVE) {
      updateOptionChainData(payload.D.S, this.massagePayload(payload));
    }
  };

  private massagePayload = (payload: ITradingStatusTopicMessage) => {
    const updatedData: ITradingStatusLiveData = {
      symbol: payload.D.S,
      isOnline: payload.D.O
    };

    return updatedData;
  };
}

export const tradingStatusTopicSubscription = new TradingStatusTopicSubscription();
